// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3r28B","col":"Table_col__3eXRT","fulfillmentStatus":"Table_fulfillmentStatus__2xGzX","emailCol":"Table_emailCol__1h55n"};